// extracted by mini-css-extract-plugin
module.exports = {"Container":"_2-h7q","Title":"_1KtOV","HideBorder":"_2cUGO","Inner":"_7Sndk","Metrics":"ZXW8r","Tags":"tiYBN"};